import _ from 'lodash';

export const encodingsSelector = state => _.get(state, 'cms.encodings', []);

export function selected(state) {
  const { encodings, selectedId } = state.cms;
  const index = encodings.map(el => el._id).indexOf(selectedId);
  if (index >= 0) {
    return encodings[index];
  }
  return null;
}

export function hasEncodings(state) {
  const { encodings } = state.cms;
  return encodings && encodings.length;
}

export function hasTones(state) {
  const sel = selected(state);
  if (sel && sel.tones && sel.tones.length) {
    return true;
  }
  return false;
}
